import type { GlobalState } from '../types';

export function updateLoginPasswordSettings<T extends GlobalState>(
  global: T,
  update: GlobalState['loginPasswordSettings'],
): T {
  return {
    ...global,
    loginPasswordSettings: {
      ...global.loginPasswordSettings,
      ...update,
    },
  };
}
